import React from 'react';

import List from '../components/list/list';

const Grid = (Screen) => <List screen={Screen} download columnConfig />;

export default Grid;